import React from 'react';
import './PasswordRequirements.css';

const PasswordRequirements = ({ password }) => {
  const requirements = [
    {
      label: 'At least 8 characters',
      test: (pwd) => pwd.length >= 8
    },
    {
      label: 'One uppercase letter (A-Z)',
      test: (pwd) => /[A-Z]/.test(pwd)
    },
    {
      label: 'One lowercase letter (a-z)',
      test: (pwd) => /[a-z]/.test(pwd)
    },
    {
      label: 'One number (0-9)',
      test: (pwd) => /\d/.test(pwd)
    },
    {
      label: 'One special character (!@#$%^&*)',
      test: (pwd) => /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/~`]/.test(pwd)
    }
  ];

  return (
    <div className="password-requirements">
      <p className="requirements-title">Password must contain:</p>
      <ul className="requirements-list">
        {requirements.map((req, index) => (
          <li 
            key={index} 
            className={req.test(password) ? 'requirement-valid' : 'requirement-invalid'}
          >
            <span className="requirement-icon">
              {req.test(password) ? '✓' : '○'}
            </span>
            {req.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
